<template>
  <div class="animated fadeIn">
    <b-card-body id="areaImprimir">
      <!--        <b-row >-->
      <!--          <b-col sm="8">-->
      <!--            <h2 class="mb-3"> {{reportType}} de guía de despacho #{{waybill.number}}</h2>-->
      <!--          </b-col>-->
      <!--          <b-col sm="4">-->
      <!--            -->
      <!--            <div id="element-to-hide" data-html2canvas-ignore="true">-->
      <!--              <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="printDiv"><i class="fa fa-lg fa-print"></i></a>&nbsp;-->
      <!--              &lt;!&ndash; <a href="#" class="btn btn-sm btn-success float-right ml-1"><i class="fa fa-send"></i> Enviar</a> &ndash;&gt;-->
      <!--              <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="descargarPDF"><i class="fa fa-lg fa-file-pdf-o"></i></a>&nbsp;-->
      <!--            </div>-->
      <!--          </b-col>-->
      <!--        </b-row>-->
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img :src="img" left fluid style="max-height: 100px;" alt="Responsive image" class="rounded pb-0"></b-img>
          <h1 class="text-right">
            {{ reportType }} <br />
            GUÍA DE DESPACHO #{{ waybill.number }}
          </h1>
          <p class="text-right">Ingreso: {{ waybill.created_at }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="mb-3">Empresa:</h6>
          <div>
            <strong>{{ waybill.company.company_name }}</strong>
          </div>
          <div>{{ waybill.company.company_number }}</div>
          <div>{{ waybill.company.address1 }}</div>
          <div>{{ waybill.company.address2 }}</div>
          <div>Email: {{ waybill.company.email }}</div>
          <div>Teléfono: {{ waybill.company.phone }}</div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Exportadora Solicitante:</h6>
          <div>
            <strong>{{ waybill.client_customer.company_name }}</strong>
          </div>
          <div>{{ waybill.client_customer.company_number }}</div>
          <div>{{ waybill.client_customer.address1 }}</div>
          <div>{{ waybill.client_customer.address2 }}</div>
          <div>Email: {{ waybill.client_customer.email }}</div>
          <div>Teléfono: {{ waybill.client_customer.phone }}</div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Detalles:</h6>
          <div>Número de guía de despacho: {{ waybill.number }}</div>
          <div>Fecha de guía de despacho: {{ waybill.waybill_date }}</div>
          <!--            <div>Fecha/Hora de arribo: {{waybill.arrival_datetime | moment}}</div>-->
          <div>Chofer: {{ waybill.truck_driver }}</div>
          <div>Patente: {{ waybill.license_plate }}</div>
          <div v-for="(field, index) in waybill.custom_fields" :key="index">
            <span v-if="field != null && field != false">
              <b>{{ index | labelize }}</b> : {{ field }}
            </span>
          </div>
        </b-col>
      </b-row>
      <h6 class="mb-3 font-weight-bold">Detalle de guía de despacho:</h6>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th class="align-middle">Pallet</th>
              <th class="align-middle">Lote</th>
              <th class="align-middle">Huerto <br />(CSG)</th>
              <th class="align-middle">Especie <br />Tipo</th>
              <th class="align-middle">Variedad</th>
              <th class="align-middle">Env./Emb.</th>
              <th class="text-center align-middle">Spec<br />(Clasf)</th>
              <th class="text-center align-middle">Cantidad</th>
              <th class="text-right align-middle">Kg Netos</th>
              <th class="text-right align-middle">Kg Brutos</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in waybill.pallets">
              <tr>
                <td :rowspan="item.contents.length + 1" class="text-center align-middle">
                  {{ index + 1 }}
                </td>
                <td :rowspan="item.contents.length + 1" class="left align-middle">
                  {{ item.number }}
                </td>
              </tr>
              <tr v-for="content in item.contents">
                <td class="left align-middle">{{ content.lot_number }}</td>
                <td class="left align-middle">
                  {{ content.origin_details.name }} <br />({{ content.origin_details.code }})
                </td>
                <td class="left align-middle">{{ content.product_name }} <br />{{ content.product_type_name }}</td>
                <td class="left align-middle">
                  {{ content.variety_name }} <br />
                  {{ content.condition }}
                </td>
                <td class="left align-middle">
                  {{ content.container.value.name }}
                </td>

                <td class="text-center align-middle">
                  {{ content.string_specs != "" ? content.string_specs : "N/A" }}
                  <br />
                  ({{ content.classification != "" ? content.classification : "N/A" }})
                  <br />
                  <div v-for="(field, index) in content.custom_fields" :key="index">
                    <span v-if="field != null && field != false"> {{ index | labelize }}: {{ field }} </span>
                  </div>
                </td>
                <td class="text-center align-middle">{{ content.quantity }}</td>
                <td class="text-right align-middle">{{ content.net_kilograms }} Kg</td>
                <td class="text-right align-middle">{{ content.gross_kilograms }} Kg</td>
              </tr>
            </template>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-center"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="text-right">TOTALES</td>
              <td class="text-center">{{ waybill.total_quantity }}</td>
              <td class="text-right">{{ waybill.total_kilograms | decimal }} Kg</td>
              <td class="text-right">{{ waybill.total_gross_kilograms | decimal }} Kg</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <b-row class="mt-3" v-if="waybill.note != ''">
        <b-col lg="12" sm="12"> <b>Notas:</b> {{ waybill.note }} </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
import locale from "numeral/locales";
import labelize from "../../assets/js/utils";

numeral.locale("es");

export default {
  name: "Report",
  props: ["waybill"],
  data() {
    return {
      img: ""
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY MM:HH");
    },
    decimal(value) {
      return numeral(value).format("0,0.00");
    },
    labelize(value) {
      return labelize(value);
    }
  },
  computed: {
    reportType() {
      return this.waybill.waybill_type === 0 ? "RECEPCIÓN " : "SALIDA ";
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
  },
  methods: {
    moment: function () {
      return moment();
    },
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open("", "", "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0");
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename: this.reportType + this.waybill.company.name + " G" + this.waybill.number + ".pdf",
        // html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped></style>
